import { API_URL_PARTNER } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";

const getPartner = (uuid: string) =>
  apiInstance({
    url: API_URL_PARTNER + uuid,
  });

export default getPartner;
